import { render, staticRenderFns } from "./JourneyConnectionDeduplicationSettings.vue?vue&type=template&id=4c02d82e&"
import script from "./JourneyConnectionDeduplicationSettings.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionDeduplicationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c02d82e')) {
      api.createRecord('4c02d82e', component.options)
    } else {
      api.reload('4c02d82e', component.options)
    }
    module.hot.accept("./JourneyConnectionDeduplicationSettings.vue?vue&type=template&id=4c02d82e&", function () {
      api.rerender('4c02d82e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/JourneyConnectionDeduplicationSettings.vue"
export default component.exports